export { default } from './UnscoredTableError'
